import { type FC } from 'react';
import { DataTableColumnTypeSymbol } from '@/components/UI/DataTableV2/headers/DataTableColumnTypeSymbol';
import styles from '@/components/UI/DataTableV2/DataTableV2.module.scss';
import { type DataTableSampleColumnV1 } from '@/model/DataTable.model';
import { _isNotBlank } from '@/littledash';
import { DateUtils } from '@/utils/Date.utils';
import { sampleColumnTooltip } from '@/components/UI/DataTableV2/headers/columnTypeSymbolTooltip';
import { useTruncationTooltip } from '@/components/UI/DataTableV2/hooks/useTruncationTooltip';

export const SampleHeaderContent: FC<{ column: DataTableSampleColumnV1 }> = ({ column }) => {
  const tooltip = sampleColumnTooltip(column);
  const labelRef = useTruncationTooltip<HTMLDivElement>(tooltip);
  const titleRef = useTruncationTooltip<HTMLDivElement>(tooltip);

  return (
    <>
      <DataTableColumnTypeSymbol type={column.type} locked={column.locked} tooltip="Sample" />
      <div className={styles.groupHeaderTextContent}>
        <div ref={labelRef} className={styles.groupHeaderLabel}>
          {column.sample.sample_type_name}
        </div>
        <div ref={titleRef} className={styles.groupHeaderTitle}>
          <span>{column.sample.planned_sample_group}</span>
          {_isNotBlank(column.sample.planned_sample_timepoint) ? (
            <span className={`${styles.label} ml2`}>
              {DateUtils.renderDuration(column.sample.planned_sample_timepoint, {
                format: 'short',
                zeros: true,
                defaultResponse: '',
              })}
            </span>
          ) : null}
        </div>
      </div>
    </>
  );
};
